import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))

export const ApproveLists = async (page, pageSize) =>
    await axios.get(process.env.REACT_APP_API_URL + `/approvelist/?page=${page}&size=${pageSize}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

    
export const ApproveSearchLists = async (data, page, pageSize) =>
     
    await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL + `/approvelist/?page=${page}&size=${pageSize}`,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: {
            searchFrom: data.searchFrom,
            searchTo: data.searchTo,
            searchEmpNo: data.searchEmpNo,
            searchLeaveType: data.searchLeaveType,
            searchStatus: data.searchStatus,
            searchText: data.searchText,
        }
    }
    )

export const RejectLeaveReqAPI = async (lId, reason) =>
    await axios({
        method: 'patch',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/reject/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: { lId, reason },
    })

export const ApproveLeaveReqAPI = async (lId, reason) =>
    await axios({
        method: 'patch',
        url: process.env.REACT_APP_API_URL + '/leaveRequest/approve/',
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: { lId, reason },
    })
